// Vendor imports
const Immutable = require('immutable')
const PropTypes = require('prop-types')
// Common Client V2 imports
const CollectionModelRecord = require('client-v2/common/models/collection/record')
const UserModelRecord = require('client-v2/common/models/user/record')
const {
  keyedReviver,
  listReviver
} = require('client-v2/common/state/record-reviver')

class ArticleProfileCollectionsRecord extends Immutable.Record({
  collections: null,
  user: null
}) {
  // No methods
}

ArticleProfileCollectionsRecord.propTypes = {
  collections: PropTypes.arrayOf(PropTypes.shape(CollectionModelRecord.propTypes)),
  user: PropTypes.shape(UserModelRecord.propTypes)
}

ArticleProfileCollectionsRecord.reviver = keyedReviver(ArticleProfileCollectionsRecord, {
  collections: listReviver(CollectionModelRecord.reviver),
  user: UserModelRecord.reviver
})

module.exports = ArticleProfileCollectionsRecord
